
import React, { useEffect, useState } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const CustomEditor = ({ value, onChange }) => {
  const [editorLoaded, setEditorLoaded] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    setEditorLoaded(true);
    return () => setEditorLoaded(false);
  }, []);

  if (!editorLoaded) {
    return <div>Loading editor...</div>;
  }

  return (
    <div key={key}>
      <CKEditor
        editor={ClassicEditor}
        data={value || ''}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
        onReady={editor => {
          console.log('Editor is ready to use!', editor);
        }}
        onError={error => {
          console.error('Editor error:', error);
          setKey(prev => prev + 1); 
        }}
        config={{
          toolbar: [
            'heading', '|',
            'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote',
            'undo', 'redo'
          ]
        }}
      />
    </div>
  );
};

export default CustomEditor;